import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { subscribePodcast, unsubscribePodcast } from '../../actions';
import { Button, message, Popconfirm } from 'antd';
import { fixedSpacing, colors, spacing } from '../../lib/theme';
import { showSubscriberCount } from '../../lib/utils';

class SubscribeOption extends Component {
    constructor(props) {
        super(props);
        this.state = { subscribed: undefined, loadingSubscribed: true, loadingConfirm: false };
    }
    onSubscribeClick(event, userDetails, title, author, imgSrc, collectionId, feedUrl, genres) {
        if (!userDetails || !userDetails.uid) {
            message.warning('Please sign in to subscribe to a podcast!');
            event.stopPropagation();
            return;
        }
        this.setState({ loadingConfirm: true });
        // console.dir(podcastInfo);
        this.props.subscribePodcast(userDetails.uid, title, author, imgSrc, collectionId, feedUrl, genres);
        event.stopPropagation();
    }
    onUnsubscribeClick(event, userDetails, podcastId) {
        if (!userDetails || !userDetails.uid) {
            message.warning('Please sign in to unsubscribe to a podcast!'); // may never happen
            event.stopPropagation();
            return;
        }
        this.setState({ loadingConfirm: true });
        this.props.unsubscribePodcast(userDetails.uid, podcastId);
        event.stopPropagation();
    }

    render() {
        return (<></>)
    }
}

SubscribeOption.propTypes = {
    userDetails: PropTypes.object,
    subscribedPodcasts: PropTypes.object,
    loadingState: PropTypes.object,
    podcast: PropTypes.object,
    type: PropTypes.string,
    itunesId: PropTypes.number,
    loadingSubscribers: PropTypes.bool,
    loadingUserDetails: PropTypes.bool,
    loadingPodcasts: PropTypes.bool,
    showSubscribers: PropTypes.bool,
    dbPodcastState: PropTypes.object,
    loadingDBPodcastData: PropTypes.bool,
    onlyshowUnsubscribe: PropTypes.bool,
    subscribers: PropTypes.number,
    subscribePodcast: PropTypes.func,
    unsubscribePodcast: PropTypes.func,
    subscribersFromParent: PropTypes.number
}
SubscribeOption.defaultProps = {
    type: 'icon',
    onlyshowUnsubscribe: false
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        subscribedPodcasts: state.podcastState,
        loadingState: state.loadingState,
        dbPodcastState: state.dbPodcastState
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        subscribePodcast: bindActionCreators(subscribePodcast, dispatch),
        unsubscribePodcast: bindActionCreators(unsubscribePodcast, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscribeOption);
